import { StateStorage } from 'zustand/middleware';
import { useTicketUserStore } from './ticket-user-store';

// Esta función que crea la clave dinámica con el id del usuario
const getDynamicKey = (name: string) => {
    const { user } = useTicketUserStore.getState();

    if (!user) return null;

    return `${name}-user-${user._id}`;
};

export const userSpecificStorage: StateStorage = {
    getItem: (name) => {
        const key = getDynamicKey(name);
        if (!key) return null;
        
        return localStorage.getItem(key);
    },
    setItem: (name, value) => {
        const key = getDynamicKey(name);
        if (!key) return;

        localStorage.setItem(key, value);
    },
    removeItem: (name) => {
        const key = getDynamicKey(name);
        if (!key) return;

        localStorage.removeItem(key);
    },
};
